const getters = {
  /**
   * 用户信息
   * @param state
   * @return {{}}
   */
  USER_INFO: state => {
    try {
      return state.USER_INFO?.Token
        ? state.USER_INFO
        : { ...JSON.parse(window.localStorage.getItem('USER_INFO')) }
    } catch {
      return {}
    }
  },
  /**
   * 用户权限
   * @param state
   * @return {{}}
   * @constructor
   */
  USER_PERMISSIONS: state => {
    try {
      return state.USER_PERMISSIONS ?? window.localStorage.getItem('USER_PERMISSIONS')?.split(',')
    } catch {
      return []
    }
  },
  /**
   * 用户组信息
   * @param state
   * @return {(function(*): (*|undefined))|*|{}}
   * @constructor
   */
  USER_GROUP: state => {
    try {
      return state.USER_GROUP?.Name
        ? state.USER_GROUP
        : { ...JSON.parse(window.localStorage.getItem('USER_GROUP')) }
    } catch {
      return {}
    }
  },
  /**
   * 返回是否记住密码
   * @param state
   * @return {boolean|boolean|any}
   * @constructor
   */
  REMEMBER_PASSWORD: state => {
    try {
      return state.REMEMBER_PASSWORD
        ? state.REMEMBER_PASSWORD
        : window.localStorage.getItem('REMEMBER_PASSWORD')
    } catch {
      return false
    }
  },
}

export default getters
